import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Auth, Hub } from 'aws-amplify';
import { Button, Preloader } from 'sharedComponents';
import { logoutUrl } from 'constants/index';
import { resetMemoryRouterStorage } from 'modules/shell/utils/router/StatefulMemoryRouter';
import { useAuthenticator } from '@aws-amplify/ui-react';

let error = null;
let timer = null;
let signOut = false;

Hub.listen('auth', (data) => {
  const { payload } = data;
  const errorDescription = payload.data && payload.data.message && payload.data.message.replace(/\+/g, ' ');
  switch (payload.event) {
    case 'signIn_failure':
      error = {
        message: payload.message,
        description: decodeURIComponent(errorDescription),
      };
      break;
    default:
      break;
  }
});

Hub.listen('osp-auth', (data) => {
  // eslint-disable-next-line prefer-destructuring
  signOut = data.payload.signOut;
});

export const Login = ({
  classes,
  location,
  authState,
  config,
  history,
  activeADGroup,
  addNotification,
  resetActiveUserADGroup,
  logger,
}) => {
  let loginAuthState = authState;

  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  if (!loginAuthState) {
    loginAuthState = authStatus;
  }

  const [showDimmer, setShowDimmer] = useState();
  const authConfig = config.get('Auth');

  if (showDimmer) {
    return <Preloader />;
  }

  if (error) {
    addNotification({
      id: `logout-${Date.now()}`,
      message: error.message,
      description: error.description,
      type: 'error',
    });
    if (logger) {
      logger.error(error);
    }

    // Reset active AD group (actual for super user)
    // More details https://neimanmarcus.atlassian.net/browse/OSP-4228
    if (activeADGroup) {
      resetActiveUserADGroup();
    }

    // reset cache of all memory routers in Connect app
    // See more details in src/modules/shell/utils/router/StatefulMemoryRouter.js
    resetMemoryRouterStorage();

    error = null;
    history.push('/logout');
    return null;
  }

  if (location.pathname === '/logout') {
    return (
      <main>
        <div className={classes.login}>
          <Button
            label="go to okta page"
            onClick={() => {
              setShowDimmer(true);
              Auth.signOut();
              window.location.href = logoutUrl(authConfig);
            }}
            data-testid="login-go-to-okta"
          />
        </div>
      </main>
    );
  }

  clearTimeout(timer);
  if (loginAuthState === 'unauthenticated' && location.search.indexOf('code') === -1 && !signOut) {
    timer = setTimeout(() => {
      Auth.federatedSignIn({ customProvider: 'SSO' });
    }, 1000);
  }

  return <Preloader />;
};

Login.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  activeADGroup: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  authState: PropTypes.string,
  resetActiveUserADGroup: PropTypes.func,
  logger: PropTypes.shape({}),
};

Login.defaultProps = {
  classes: {},
  resetActiveUserADGroup: () => null,
};

export default Login;
